'use client';

import './style.sass';
import '../reusable-components/style.sass';

import React from 'react';

import { listPath, listTitle } from './constants';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import Review from '../reusable-components/layouts-components__common-cases/review';
import Complex from '../reusable-components/layouts-components__skolkovo/complex';
import Customer from '../reusable-components/layouts-components__skolkovo/customer';
import Process from '../reusable-components/layouts-components__skolkovo/process';
import Results from '../reusable-components/layouts-components__skolkovo/results';
import SliderSkolkovo from '../reusable-components/layouts-components__skolkovo/sliderskolkovo';
import Task from '../reusable-components/layouts-components__skolkovo/task';
import Team from '../reusable-components/layouts-components__skolkovo/team';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';

const reviewSkolkovo = {
    reviewText:
        'Результат работы однозначно можно назвать успешным, благодаря этому опыту есть понимание движения в&nbsp;улучшении продуктов Технопарка &laquo;Сколково&raquo;. Сформированы проблемные места и&nbsp;масштабируемые направления.',
    reviewAuthors: [
        {
            title: 'Мария Кравченко',
            subtitle: 'Руководитель департамента внешних коммуникаций',
            img: '/images/svg/skolkovo/review__author-img.jpg',
        },
    ],
    downLoadPresentationText: '&nbsp; Получить презентацию кейса',
};

const nextProjectSkolkovo = {
    nextProjectTitle: 'Увеличение трафика сайта для «МТС Инвестиции»',
    nextProjectImg: '/images/pic/preview/mts.png',
    nextProjectLink: '/cases/marketing/mts-invest',
    nextProjectLinkTitle: 'МТС Инвестиции',
    nextProjectText:
        'В 4 раза увеличили показатель роста трафика на блог, в 2 раза увеличили объем проиндексированных страниц сайта и посещаемость на новые тематические посадочные страницы',
};

const Skolkovo = () => {
    return (
        <section className="skolkovo">
            <TitleCase
                img="/images/pic/skolkovo12/skolkovo12banner.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="skolkovo12"
            />

            <Customer />

            <Task />

            <Complex />

            <Process />

            <SliderSkolkovo />

            <Results />

            <Team />

            <Review Review={reviewSkolkovo} />
            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>

            <NextProject NextProject={nextProjectSkolkovo} />
        </section>
    );
};

export default Skolkovo;
